import React from 'react';

import { createSvgIcon } from '@mui/material/utils';
import phone from '@mui/icons-material/Phone';
import phoneOutlined from '@mui/icons-material/PhoneOutlined';

import videoCam from '@mui/icons-material/Videocam';
import videoCamOutline from '@mui/icons-material/VideocamOutlined';

import onsite from '@mui/icons-material/Place';
import onSiteOutlined from '@mui/icons-material/PlaceOutlined';

import signLanguage from '@mui/icons-material/SignLanguage';
import signLanguageOutlined from '@mui/icons-material/SignLanguageOutlined';

import description from '@mui/icons-material/Description';
import descriptionOutlined from '@mui/icons-material/DescriptionOutlined';

import forum from '@mui/icons-material/Forum';
import forumOutlined from '@mui/icons-material/ForumOutlined';

import message from '@mui/icons-material/Message';
import messageOutlined from '@mui/icons-material/MessageOutlined';

import interpreterMode from '@mui/icons-material/InterpreterMode';
import interpreterModeOutlined from '@mui/icons-material/InterpreterModeOutlined';

import translate from '@mui/icons-material/Translate';
import translateOutlined from '@mui/icons-material/TranslateOutlined';

import pinDrop from '@mui/icons-material/PinDrop';
import pinDropOutlined from '@mui/icons-material/PinDropOutlined';

const videoOnsite = createSvgIcon(
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 5.08v-3.5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v5c4-1 7 3 6 6h7c.55 0 1-.45 1-1v-3.5l2.29 2.29c.63.63 1.71.18 1.71-.71V3.49c0-.89-1.08-1.34-1.71-.71L17 5.08Z"
      fill="currentColor"
    />
    <path
      d="M4 7.58c-2.1 0-4 1.61-4 4.1 0 1.59 1.225 3.46 3.67 5.616.19.165.475.165.665 0C6.775 15.14 8 13.27 8 11.68c0-2.49-1.9-4.1-4-4.1Zm0 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z"
      fill="currentColor"
    />
  </svg>,
  'videoOnsite',
);

const videoOnsiteOutlined = createSvgIcon(
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 5.08v-3.5c0-.275-.225-.5-.5-.5H4.5c-.275 0-.5.225-.5.5v4.4c3.4-.825 5.95 2.575 5.125 5.1h6.375c.275 0 .5-.225.5-.5v-3.5l2.09 2.09c.315.315.855.09.855-.355V3.49c0-.445-.54-.67-.855-.355L16 5.08Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M4 8.38c-1.6 0-3 1.17-3 3.3 0 1.35.925 2.74 2.82 4.22.16.14.4.14.56 0 1.895-1.48 2.82-2.87 2.82-4.22 0-2.13-1.4-3.3-3.2-3.3Zm0 4.3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>,
  'videoOnsiteOutlined',
);

const vendorNow = createSvgIcon(
  <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.30078 0H12.3008C13.4008 0 14.3008 0.9 14.3008 2V4C14.3008 4.55 13.8508 5 13.3008 5C12.7508 5 12.3008 4.55 12.3008 4V3H2.30078V19H12.3008V18C12.3008 17.45 12.7508 17 13.3008 17C13.8508 17 14.3008 17.45 14.3008 18V20C14.3008 21.1 13.4008 22 12.3008 22H2.30078C1.20078 22 0.300783 21.1 0.300783 20V2C0.300783 0.9 1.20078 0 2.30078 0Z" fill="currentColor" />
    <path d="M11.2852 6.54167V11.4167C11.2852 11.7146 11.5289 11.9583 11.8268 11.9583H12.9102V15.8313C12.9102 16.1075 13.2731 16.205 13.4139 15.9667L16.2252 11.1458C16.4364 10.7829 16.1764 10.3333 15.7593 10.3333H14.5352L15.8839 6.73125C16.0193 6.37917 15.7593 6 15.3802 6H11.8268C11.5289 6 11.2852 6.24375 11.2852 6.54167Z" fill="currentColor" />
  </svg>,
  'vendorNow',
);

const vendorNowOutlined = createSvgIcon(
  <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M2.30078 0.6h10c.66 0 1.2.54 1.2 1.2v2c0 .33-.27.6-.6.6s-.6-.27-.6-.6V2.4H2.00078v16.2h10.3v-1c0-.33.27-.6.6-.6s.6.27.6.6v2c0 .66-.54 1.2-1.2 1.2h-10c-.66 0-1.2-.54-1.2-1.2V2c0-.66.54-1.2 1.2-1.2z" 
      stroke="currentColor" 
      strokeWidth="1.2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path 
      d="M11.2852 6.54167v4.87503h1.625v3.875l2.815-4.375h-1.625l1.315-4.375h-3.63c-.3 0-.5.2-.5.5z" 
      stroke="currentColor" 
      strokeWidth="1.2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'vendorNowOutlined',
);

// call interpreter
// import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';

// service_offerings
const interpretation = forum;
const interpretation_outlined = forumOutlined;

const translation = translate;
const translation_outlined = translateOutlined;

// service_types interpretation
const phone_interpretation = phone;
const phone_interpretation_outlined = phoneOutlined;

const video = videoCam;
const video_outlined = videoCamOutline;

const video_on_site = videoOnsite;
const video_on_site_outlined = videoOnsiteOutlined;

const on_site = onsite;
const on_site_outlined = onSiteOutlined;

const vendor_now = vendorNow;
const vendor_now_outlined = vendorNowOutlined;

const message_interpretation = message;
const message_interpretation_outlined = messageOutlined;

const sign_language = signLanguage;
const sign_language_outlined = signLanguageOutlined;

const on_site_pin_drop = pinDrop;
const on_site_pin_drop_outlined = pinDropOutlined;

// service_types translation
const translation_covered = description;
const translation_covered_outlined = descriptionOutlined;

const proofreading = description;
const proofreading_outlined = descriptionOutlined;

const language_review = message;
const language_review_outlined = messageOutlined;

const conference = interpreterMode;
const conference_outlined = interpreterModeOutlined;

export {
  interpretation,
  interpretation_outlined,

  translation,
  translation_outlined,

  phone_interpretation,
  phone_interpretation_outlined,

  video,
  video_outlined,

  videoOnsite,
  videoOnsiteOutlined,
  video_on_site,
  video_on_site_outlined,

  onsite,
  on_site,
  on_site_outlined,

  vendorNow,
  vendorNowOutlined,
  vendor_now,
  vendor_now_outlined,

  on_site_pin_drop,
  on_site_pin_drop_outlined,

  message_interpretation,
  message_interpretation_outlined,

  signLanguage,
  signLanguageOutlined,
  sign_language,
  sign_language_outlined,

  translation_covered,
  translation_covered_outlined,

  proofreading,
  proofreading_outlined,

  language_review,
  language_review_outlined,

  conference,
  conference_outlined,
  
  message,
  phone,
}
